// Kept identical to tcs-fse/src/utils/expertLink/consts.ts.
export const EXPERTLINK_FLAG = 'expertlink';

export const EXPERTLINK_BRAND = 'Massey Ferguson';

// Lower case so the comparison accepts both values the backend returns for the category: `key`
// ("tractors") where it resolves and `defaultDisplayName` ("Tractors") where it does not.
export const EXPERTLINK_CATEGORY_KEY = 'tractors';
